import React from 'react';
import { renderChildren } from '@fiverr-private/ui_utils';
import { Center } from '@fiverr-private/layout_components';
import { InputGroupChildProps } from '../types';
import { PREFIX_ID } from '../constants';

const InputPrefix = ({ children, disabled }: InputGroupChildProps) => (
  <Center paddingRight="1" height="100%">
    {renderChildren(children, { disabled })}
  </Center>
);

InputPrefix.displayName = PREFIX_ID;
Object.assign(InputPrefix, { id: PREFIX_ID });

export default InputPrefix;
